import { render } from "./OurSocial.vue?vue&type=template&id=427c86b5&scoped=true"
import script from "./OurSocial.vue?vue&type=script&lang=js"
export * from "./OurSocial.vue?vue&type=script&lang=js"

import "./OurSocial.vue?vue&type=style&index=0&id=427c86b5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-427c86b5"]])

export default __exports__